export default "__VITE_ASSET__ff1bdb54__"